import { keys } from '../../query/keyRegistry';

export const menuKeys = {
  day: (customer_id: number, date_ymd: string, is_double_box: boolean) =>
    keys.customer(customer_id).foodMenu(date_ymd, is_double_box),
  all: (customer_id: number) => keys.customer(customer_id).foodMenuAll,
  guestPreview: (date_ymd: string) => ['food-menu', 'guest-preview', date_ymd] as const,
};
